import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Anchorme } from "react-anchorme";

const StyledB = styled.b`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

const StyledMark = styled.mark`
  background-color: #fdf396;
  color: #000;
`;

const TAG_REGEX = /#([\p{L}\p{N}_]+)/gu;

function renderPlainSegment(segment, searchTerm) {
  if (!searchTerm) return <Anchorme target="_blank">{segment}</Anchorme>;
  const escaped = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`(${escaped})`, "gi");
  return segment
    .split(regex)
    .map((part, i) =>
      i % 2 === 1 ? <StyledMark key={i}>{part}</StyledMark> : part
    );
}

function renderWithTags(text, searchTerm) {
  return text.split(TAG_REGEX).map((part, i) =>
    i % 2 === 1 ? (
      <Link key={i} to={`/tags/${part.toLowerCase()}`}>
        #{part}
      </Link>
    ) : (
      <React.Fragment key={i}>
        {renderPlainSegment(part, searchTerm)}
      </React.Fragment>
    )
  );
}

const SmartText = ({ text, length = 200, url, searchTerm }) => {
  const [showLess, setShowLess] = React.useState(true);

  const renderText = t => renderWithTags(t, searchTerm);

  if (text.length < length || url !== "/journals") {
    return renderText(text);
  }

  return (
    <React.Fragment>
      {renderText(showLess ? `${text.slice(0, length)}…` : text)}
      &nbsp;
      <StyledB onClick={() => setShowLess(!showLess)}>
        See {showLess ? "More" : "Less"}
      </StyledB>
    </React.Fragment>
  );
};

export default SmartText;
